export function pluralizeWord(word: string) {
  return isAlreadyPlural(word) ? word : pluralize(word);
}

function isAlreadyPlural(word: string) {
  return (
    word.endsWith('ies') ||
    word.endsWith('es') ||
    (word.endsWith('s') && !word.endsWith('ss') && !word.endsWith('us') && !word.endsWith('is'))
  );
}

function pluralize(word: string) {
  // if the word is in the irregulars list, return the plural form
  if (IRREGULARS[word]) {
    return IRREGULARS[word];
  }
  // if the word ends in 'y' and is not preceded by a vowel, add 'ies'
  if (word.endsWith('y') && !/[aeiou]y$/.test(word)) {
    return word.replace(/y$/, 'ies');
  }
  // if the word ends in 'ch', 'sh', 's', 'x', or 'z', add 'es'
  if (word.endsWith('ch') || word.endsWith('sh') || word.endsWith('s') || word.endsWith('x') || word.endsWith('z')) {
    return `${word}es`;
  }
  // otherwise, add 's'
  return `${word}s`;
}

const IRREGULARS: { [word: string]: string } = {
  is: 'are',
  person: 'people',
  more: 'more',
  this: 'these',
  that: 'those',
  child: 'children',
  children: 'children',
  people: 'people',
};
